export const numbersInHungarian = [
  "Első",
  "Második",
  "Harmadik",
  "Negyedik",
  "Ötödik",
  "Hatodik",
  "Hetedik",
  "Nyolcadik",
  "Kilencedik",
  "Tizedik",
  "Tizenegyedik",
  "Tizenkettedik",
  "Tizenharmadik",
  "Tizennegyedik",
  "Tizenötödik",
  "Tizenhatodik",
  "Tizenhetedik",
  "Tizennyolcadik",
  "Tizenkilencedik",
  "Huszonödik",
  "Huszonegyedik",
  "Huszontizedik",
  "Huszonnegyedik",
  "Huszonötödik",
  "Huszonhatodik",
  "Huszonhetedik",
  "Huszonnyolcadik",
  "Huszonkilencedik",
  "Harmincadik",
  "Harmincegyedik",
  "Harminckettedik",
  "Harmincharmadik",
  "Harmincnegyedik",
  "Harmincötödik",
  "Harminchatodik",
  "Harminchetedik",
  "Harmincnyolcadik",
  "Harminckilencedik",
  "Negyvenedik",
  "Negyvenegyedik",
  "Negyvenkettedik",
  "Negyvenharmadik",
  "Negyvennegyedik",
  "Negyvenötödik",
  "Negyvenhatodik",
  "Negyvenhetedik",
  "Negyvennyolcadik",
  "Negyvenkilencedik",
  "Ötvenedik",
  "Ötvenegyedik",
  "Ötvenkettedik",
  "Ötvenharmadik",
  "Ötvennegyedik",
  "Ötvenötödik",
  "Ötvenhatodik",
  "Ötvenhetedik",
  "Ötvennyolcadik",
  "Ötvenkilencedik",
  "Hatvanadik",
  "Hatvane gyedik",
  "Hatvanharmadik",
  "Hatvannegyedik",
  "Hatvanötödik",
  "Hatvanhatodik",
  "Hatvanhetedik",
  "Hatvannyolcadik",
  "Hatvankilencedik",
  "Hetvenedik",
  "Hetvenegyedik",
  "Hetvenkettedik",
  "Hetvenharmadik",
  "Hetvennegyedik",
  "Hetvenötödik",
  "Hetvenhatodik",
  "Hetvenhetedik",
  "Hetvennyolcadik",
  "Hetvenkilencedik",
  "Nyolcvanadik",
  "Nyolcvanegyedik",
  "Nyolcvankettedik",
  "Nyolcvanharmadik",
  "Nyolcvannegyedik",
  "Nyolcvanötödik",
  "Nyolcvanhatodik",
  "Nyolcvanhetedik",
  "Nyolcvannyolcadik",
  "Nyolcvankilencedik",
  "Kilencvenedik",
  "Kilencvenegyedik",
  "Kilencvenkettedik",
  "Kilencvenharmadik",
  "Kilencvennegyedik",
  "Kilencvenötödik",
  "Kilencvenhatodik",
  "Kilencvenhetedik",
  "Kilencvennyolcadik",
  "Kilencvenkilencedik",
  "Századik",
];
